<template>
    <div class="impersonate-bar" v-if="user">
        <a href="/impersonate/stop" rel="no-follow">
            <div class="container-fluid">
                You are currently impersonating <strong>{{ user.name }}</strong>, click this bar to stop
            </div>
        </a>
    </div>
</template>

<script>
    import User from '../../Services/User';

    export default {
        data() {
            return {
                user: null
            }
        },
        mounted() {
            User.current().then(response => {
                this.user = response;
            });
        }
    }
</script>

<style lang="scss" scoped>
    .impersonate-bar {
        background-color:#333;
        background-image:url('/images/stripe.svg');
        background-size:25px;
        background-repeat: repeat-x;
        background-position: bottom left;
        a {
            padding:1em 0;
            font-size:.775em;
            display:block;
            color:#f5f5f5;
        }
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/Components/Elements/ImpersonateBar.vue